// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/TicketAgingSection.js
//
// Purpose:
// Ticket Aging Analysis
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from "recharts";

import DashboardCard
  from "./DashboardCard";

export default function TicketAgingSection({

  data = [],

  onBucketClick,

}) {

  function handleClick(row) {

    if (
      !row ||
      !onBucketClick
    ) {
      return;
    }

    onBucketClick(
      row.bucket
    );
  }

  return (

    <DashboardCard

      title="Ticket Aging Analysis"

      subtitle="Open tickets grouped by age bucket"

      height={450}

    >

      <ResponsiveContainer
        width="100%"
        height="90%"
      >

        <BarChart
          data={data}
          layout="vertical"
        >

          <CartesianGrid
            strokeDasharray="3 3"
          />

          <XAxis
            type="number"
          />

          <YAxis
            type="category"
            dataKey="bucket"
            width={120}
          />

          <Tooltip />

          <Bar
            dataKey="count"
            radius={[0, 6, 6, 0]}
            onClick={handleClick}
          >

            {data.map(
              (entry, index) => (

                <Cell
                  key={index}
                  fill={
                    index === 0
                      ? "#10b981"
                      : index === 1
                      ? "#f59e0b"
                      : index === 2
                      ? "#f97316"
                      : "#dc2626"
                  }
                />

              )
            )}

          </Bar>

        </BarChart>

      </ResponsiveContainer>

    </DashboardCard>

  );
}